import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';
import Dialog from 'material-ui/Dialog';
import { resourceApi } from '../utils/fetchUtil';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import Divider from 'material-ui/Divider';
import { cdnPath } from '../constants/config';


// require('highcharts-more')(ReactHighcharts.Highcharts);
// require('highcharts/modules/solid-gauge')(ReactHighcharts.Highcharts);


const styles = {

    mediumIcon: {
        color: '#666',
        width: 40,
        height: 40,
    },
    medium: {
        width: 40,
        height: 40,
        float: 'right',
        padding: 0
    }
}


class Accumulator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            family: [],
            alertMessage: "",
            open: false,
            accumulators: [],
            selectedClientUserID: this.props.member.ClientUserID,
            lastUpdated: null,
            noData: false,
        };
    }

    componentDidMount = () => {
        // console.log("Accumulator.js", this.props)
    }

    computeCompleted = (planVal, currVal) => {
        return parseInt(((currVal / planVal) * 100));
    }

    formatMoney = (number, decPlaces = 0, decSep = ".", thouSep = ",") => {
        if(number != null){
            decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
            decSep = typeof decSep === "undefined" ? "." : decSep;
            thouSep = typeof thouSep === "undefined" ? "," : thouSep;
            var sign = number < 0 ? "-" : "";
            var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
            var j = (j = i.length) > 3 ? j % 3 : 0;
            
            return "$" + sign +
                (j ? i.substr(0, j) + thouSep : "") +
                i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
                (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
        }

    }
        
    handleClose = () => {
        this.setState({ open: false });
    }

    handleChange = (event, index, value) => {
        this.setState({ selectedClientUserID: value });
        this.loadAccumulator(value);
    }

    render() {
        const actions = [
            <FlatButton
                label="Close"
                primary={true}
                onClick={this.handleClose}
            />
        ];

        const headerStyle = {
            color:"#000000",
            fontFamily:"truenoLight",
            fontSize:"14pt"
        }

        const primeLight = getMuiTheme(window.muiTheme).palette.primary1Color+"45"




        return (
            <div>

                {!this.state.isFetching && (
                    <div>
                        {/* <h3>{this.props.plan.Networks.length > 0 ? `Network: ${this.props.plan.Networks[0].Name}` : `Plan: ${this.props.plan.Name}`}</h3> */}
                        {this.props.plan.Networks.length > 0 && this.props.plan.Networks[0].LogoUrl && (
                            <div >
                                <img src={`https://${cdnPath}/networkimages/` + this.props.plan.Networks[0].LogoUrl} style={{height:40, paddingBottom: 5}} />
                                <Divider style={{ width: '100%', margin:'5px 0 5px 0' }} />
                            </div>
                        )}
                        {this.props.plan.Networks.length > 0 && !this.props.plan.Networks[0].LogoUrl && (
                            <div >
                                <div style={{...headerStyle, fontSize:"16pt"}}>{this.props.plan.Networks[0].Name}</div>
                                <br />
                                <Divider style={{ width: '100%', margin:'5px 0 5px 0' }} />
                            </div>
                        )}
                        {this.props.plan.Accumulators.map((a, index) => (
                                <div key={index}>
                                    <div style={{ textAlign: 'left' }}>
                                        <div>
                                            <div style={headerStyle}>{a.Name}</div>
                                            <span style={{ fontSize: '14px', color: '#999999' }}>{a.Tooltip}</span>
                                        </div>
                                        <div style={{ width: '100%', margin: '0 auto' }} >
                                            {a.PlanValue && (
                                                <div  style={{paddingTop: 4}}>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ textAlign: 'left' }}>
                                                                    <b>Individual</b>
                                                                    <br />
                                                                    <span>{this.formatMoney(a.CurrentValue)} Spent </span>
                                                                </td>
                                                                <td style={{verticalAlign: 'bottom'}}>
                                                                    <span style={{ float: 'right' }}> Out of {this.formatMoney(a.PlanValue)}</span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div style={{padding:"5px 0"}}>
                                                    <LinearProgress mode="determinate" value={this.computeCompleted(a.PlanValue, a.CurrentValue)} style={{ background: primeLight, height: 15 }} />
                                                    </div>

                                                </div>
                                            )}
                                            {a.FamilyPlanValue && (
                                                <div style={{paddingTop: 5}}>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ textAlign: 'left' }}>
                                                                    <b>Family</b>
                                                                    <br />
                                                                    <span>{this.formatMoney(a.FamilyCurrentValue)} Spent</span>
                                                                </td>
                                                                <td style={{verticalAlign: 'bottom'}}>
                                                                    <span style={{ float: 'right' }}> Out of {this.formatMoney(a.FamilyPlanValue)}</span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div style={{padding:"5px 0"}}>
                                                    <LinearProgress mode="determinate" value={this.computeCompleted(a.FamilyPlanValue, a.FamilyCurrentValue)} style={{ background: primeLight, height: 15 }} />
                                                    </div>
                                                </div>
                                            )}
                                        <br />
                                        </div>
                                        <br />
                                    </div>
                                    {((index + 1) === this.props.plan.Accumulators.length) && (
                                        <div style={{ textAlign: 'center', paddingBottom: '10px' }}>
                                            <span style={{ fontSize: '14px', color: '#999999' }}>Last Updated: {a.LastUpdated}</span>
                                        </div>
                                    )}
                                </div>
                            ))}



                            {this.state.noData && (
                                <p>No data available</p>
                            )}


                        {!this.state.noData && this.props.plan.AccumulatorDisclosures.length > 0 && this.props.plan.AccumulatorDisclosures.map((ad, index) => (
                            <div key={index} style={{padding: '10px'}}>
                            <span style={{ textAlign: 'center', fontSize: '14px', color: '#999999' }}>{ad.Text}</span>
                        </div>
                        ))}

                        <Dialog
                            actions={actions}
                            modal={false}
                            open={this.state.open}
                            onRequestClose={this.handleClose} >
                            <p>{this.state.alertMessage}</p>
                        </Dialog>
                    </div>
                )}
            </div>
        );
    }
};

export default Accumulator;




// WEBPACK FOOTER //
// ./src/Components/Accumulator.js